/**
 * @generated SignedSource<<9f85c08398d11135b9c5906da2fa1231>>
 * @relayHash e4fc157144ff80433929db438252274a
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID e6d8a439313151ac4be2392b04a56ad04abc753676cb8a365d2172b825c4f835

import type { ConcreteRequest } from 'relay-runtime';
export type useMovePageHandlerMovePageBeforeMutation$variables = {
  pageId: string;
  siblingId: string;
};
export type useMovePageHandlerMovePageBeforeMutation$data = {
  readonly movePageBefore: {
    readonly page: {
      readonly id: string | null;
      readonly links: {
        readonly editui: string | null;
        readonly webui: string | null;
      } | null;
    } | null;
  } | null;
};
export type useMovePageHandlerMovePageBeforeMutation = {
  response: useMovePageHandlerMovePageBeforeMutation$data;
  variables: useMovePageHandlerMovePageBeforeMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "pageId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "siblingId"
  }
],
v1 = [
  {
    "args": [
      {
        "fields": [
          {
            "kind": "Variable",
            "name": "pageId",
            "variableName": "pageId"
          },
          {
            "kind": "Variable",
            "name": "siblingId",
            "variableName": "siblingId"
          }
        ],
        "kind": "ObjectValue",
        "name": "input"
      }
    ],
    "concreteType": "MovePagePayload",
    "kind": "LinkedField",
    "name": "movePageBefore",
    "plural": false,
    "selections": [
      {
        "concreteType": "Page",
        "kind": "LinkedField",
        "name": "page",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "id"
          },
          {
            "concreteType": "Map_LinkType_String",
            "kind": "LinkedField",
            "name": "links",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "webui"
              },
              {
                "kind": "ScalarField",
                "name": "editui"
              }
            ]
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "useMovePageHandlerMovePageBeforeMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useMovePageHandlerMovePageBeforeMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "e4fc157144ff80433929db438252274a",
    "id": "e6d8a439313151ac4be2392b04a56ad04abc753676cb8a365d2172b825c4f835",
    "metadata": {},
    "name": "useMovePageHandlerMovePageBeforeMutation",
    "operationKind": "mutation",
    "text": "mutation useMovePageHandlerMovePageBeforeMutation($pageId:ID!,$siblingId:ID!){movePageBefore(input:{pageId:$pageId,siblingId:$siblingId}){page{id,links{webui,editui}}}}"
  }
};
})();

(node as any).hash = "4c865d6cf9059b124024ddd239f00b20";

export default node;
